module.exports = __webpack_public_path__ + "img/circulo_prevenida.a1b3e917.gif";